import React from "react";
import { Calendar, MapPin, Users, Flower, BookOpen, Award } from "lucide-react";
import Image from "../images/aboutus.jpg";
import Pngone from "../images/png1.svg";
import Pngtwo from "../images/png2.svg";
import Pngtwoo from "../images/png3.svg";
import Retreat1 from "../images/16ee1062-3ab0-4770-a290-149e539da501.JPG";
import Retreat2 from "../images/58e27f66-8565-43a2-96b6-56f17756c2fc.JPG";
import Retreat3 from "../images/25546eab-171c-4e4d-b947-0ebfb7f0f9f3.JPG";
import Retreat4 from "../images/dc2b3017-2910-44f7-9cd1-166f37e841fa.JPG";
import Retreat5 from "../images/7d00fba9-c5b7-4502-af03-6d4a4f6e124f.JPG";
import Retreat6 from "../images/retreat6.png";
import Retreat7 from "../images/retreat7.png";
import Retreat8 from "../images/retreat8.png";
import Retreat9 from "../images/retreat9.jpg";
import Retreat10 from "../images/retreat10.jpg";
import Retreat11 from "../images/retreat11.jpg";
import Retreat12 from "../images/retreat12.jpg";
import Retreat13 from "../images/retreat13.jpg";
import Retreat14 from "../images/retreat14.jpg";
import Retreat15 from "../images/retreat15.jpg";
import Retreat16 from "../images/retreat16.jpg";

const Retreat = () => {
  // Your original retreat images
  const retreatImages = [
    Retreat1,
    Retreat2,
    Retreat3,
    Retreat4,
    Retreat5,
    Retreat6,
    Retreat7,
    Retreat8,
    Retreat9,
    Retreat10,
    Retreat11,
    Retreat12,
    Retreat13,
    Retreat14,
    Retreat15,
    Retreat16,
  ];

  const [currentImage, setCurrentImage] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % retreatImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const features = [
    {
      icon: <img src={Pngone} alt="" className="w-8 h-8" />,
      text: "Daily meditation, breath-work and yoga"
    },
    {
      icon: <img src={Pngtwo} alt="" className="w-8 h-8" />,
      text: "Inspiring lectures"
    },
    {
      icon: <img src={Pngtwoo} alt="" className="w-8 h-8" />,
      text: "Certified and experienced team members"
    }
  ];

  return (
    <div className="w-full min-h-screen  ">
      {/* Hero Section */}
      <div className="relative overflow-hidden bg-white">
        <div className="absolute "></div>
        <div className="relative px-4 py-16 md:py-24">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-light text-amber-900 mb-8 leading-tight">
              Why Take a <span className="text-[#824332] font-normal">Retreat</span>?
            </h1>
            <p className="text-lg md:text-xl text-black leading-relaxed max-w-3xl mx-auto">
              Have you ever noticed that after a holiday or a period of rest, we
              tend to make clearer decisions? A retreat offers a unique
              opportunity to focus on yourself and see where you are at this exact
              moment in your life. It's a chance to take the deep rest needed to
              see clearly your cherished path ahead.
            </p>
            <div className="mt-8 p-6 bg-white/60 backdrop-blur-sm rounded-2xl border border-[#824332] inline-block">
              <p className="text-amber-900 font-medium italic">
                Taking a retreat reminds us that life is not happening to us but for us.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Upcoming Event Banner */}
      <div className="px-4 py-12">
        <div className="max-w-6xl mx-auto">
          <div className="rounded-3xl p-8 md:p-16 text-center text-black shadow-2xl transform hover:scale-105 transition-transform duration-300">
            <div className="space-y-4">
              <h2 className="text-5xl md:text-7xl font-thin tracking-wide">
                Upcoming Event
              </h2>
              <div className="w-24 h-1 bg-white/80 mx-auto rounded-full"></div>
              <p className="text-xl md:text-2xl font-light max-w-2xl mx-auto leading-relaxed">
                Join us for a transformative journey where you'll experience the light within you and live your true potential.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="px-4 py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-5 gap-8 lg:gap-12">
            
            {/* Left Side - Details */}
            <div className="lg:col-span-2 space-y-8">
              
              {/* Date Section */}
              <div className="bg-white rounded-2xl p-6 shadow-lg border border-[#824332]">
                <div className="flex items-center gap-3 mb-4">
                  <Calendar className="w-6 h-6 text-amber-800" />
                  <h3 className="text-2xl font-light text-amber-900">Event Details</h3>
                </div>
                <div className="space-y-2 text-amber-800">
                  <p className="text-lg">Duration: 10 Days</p>
                  <p className="text-sm text-amber-800">Dates to be announced</p>
                </div>
              </div>

              {/* Features */}
              <div className="bg-white rounded-2xl p-6 shadow-lg border border-[#824332]">
                <h3 className="text-2xl font-light text-amber-900 mb-6">What's Included</h3>
                <div className="space-y-4">
                  {features.map((feature, index) => (
                    <div key={index} className="flex items-start gap-4 p-3 rounded-xl hover:bg-amber-50 transition-colors duration-200">
                      <div className="flex-shrink-0 p-2  rounded-full">
                        {feature.icon}
                      </div>
                      <p className="text-lg text-amber-800 leading-relaxed">
                        {feature.text}
                      </p>
                    </div>
                  ))}
                </div>
              </div>

              {/* CTA Button */}
              <div className="text-center lg:text-left">
                <a
                  href="http://Yogalife.be/antastha-yatra"
                  className="inline-flex items-center gap-3 px-8 py-4 bg-[#824332] text-white rounded-full font-medium text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
                >
                  <span>Book Now</span>
                  <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                </a>
              </div>
            </div>

            {/* Right Side - Image Gallery */}
            <div className="lg:col-span-3">
              <div className="bg-white rounded-3xl p-6 shadow-xl border border-amber-800">
                <div className="mb-6">
                  <h2 className="text-3xl md:text-4xl font-light text-amber-900 text-center lg:text-left">
                    10 Day Yoga Retreat
                  </h2>
                  <div className="w-16 h-1 bg-[#824332] rounded-full mt-3 mx-auto lg:mx-0"></div>
                </div>
                
                <div className="relative h-96 md:h-[500px] rounded-2xl overflow-hidden shadow-inner">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent z-10"></div>
                  {retreatImages.map((image, index) => (
                    <img
                      key={index}
                      src={image}
                      alt={`Retreat scene ${index + 1}`}
                      className={`absolute  w-full h-full object-cover transition-opacity duration-1000 ${
                        index === currentImage ? 'opacity-100' : 'opacity-0'
                      }`}
                    />
                  ))}
                  
                  {/* Image Indicators */}
                  <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 z-20">
                    {retreatImages.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentImage(index)}
                        className={`w-3 h-3 rounded-full transition-all duration-300 ${
                          index === currentImage 
                            ? 'bg-white shadow-lg' 
                            : 'bg-white/50 hover:bg-white/75'
                        }`}
                      />
                    ))}
                  </div>

                  {/* Floating Badge */}
                  <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-full px-4 py-2 z-20">
                    <div className="flex items-center gap-2">
                      <MapPin className="w-4 h-4 text-amber-600" />
                      <span className="text-sm font-medium text-amber-900">Immersive Experience</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="px-4 py-16 ">
        <div className="max-w-4xl mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <Users className="w-8 h-8 text-amber-600" />
            <h3 className="text-2xl font-light text-amber-900">Join Our Community</h3>
          </div>
          <p className="text-lg text-amber-800 leading-relaxed">
            Connect with like-minded individuals on a journey of self-discovery and inner peace. 
            Our retreats create lasting bonds and transformative experiences.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Retreat;